/**
 * @title Terms and Conditions Dialog
 * @description The dialog shown when the user clicks to read the terms and conditions
 * @image https://storageaccountourimbea2.blob.core.windows.net/tradein2guide/mainpage-termsconditions.png
 */
import * as React from "react";
import {FC} from "react";
import {Dialog, DialogContentText, IconButton} from "@mui/material";
import DialogTitle from "@mui/material/DialogTitle";
import {StyledTypography} from "../providers/layout/LayoutProvider";
import {CloseIcon} from "../svg/SvgIcons";
import {useRecoilValue} from "recoil";
import {LocalizationsAtom} from "../providers/localization/LocalizationProvider";

export interface TermsAndConditionsDialogProps {
  open: boolean;
  onHideDialog: () => void;
  fullScreen?: boolean;
}

export const TermsAndConditionsDialog: FC<TermsAndConditionsDialogProps> = ({
  open,
  onHideDialog,
  fullScreen = false
}) => {
  const localizations = useRecoilValue(LocalizationsAtom);

  return (
    <Dialog onClose={onHideDialog} open={open} fullScreen={fullScreen} maxWidth={"sm"}>
      <DialogTitle
        sx={{display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center'}}>
        <div style={{width: '100%', textAlign: 'center'}}>
          <StyledTypography type={"main"} variant={"h2"}>
            {localizations.consumerConfirmTermsTitle || 'Terms'}
          </StyledTypography>
        </div>
        <IconButton onClick={onHideDialog}>
          <CloseIcon/>
        </IconButton>
      </DialogTitle>
      <DialogContentText style={{padding: '0 30px 30px 30px'}}>
        <div style={{width: '100%', marginBottom: '20px'}}>
          <StyledTypography type={"main"} variant={"body1"}
                          dangerouslySetInnerHTML={{__html: localizations.consumerConfirmTerms}}/>
        </div>
        <div style={{width: '100%', marginBottom: '20px'}}>
          <StyledTypography type={"main"} variant={"body1"}
                          dangerouslySetInnerHTML={{__html: localizations.consumerConfirmTerms1}}/>
        </div>
        <div style={{width: '100%', marginBottom: '20px'}}>
          <StyledTypography type={"main"} variant={"body1"}
                          dangerouslySetInnerHTML={{__html: localizations.consumerConfirmTerms2}}/>
        </div>
        <div style={{width: '100%', marginBottom: '20px'}}>
          <StyledTypography type={"main"} variant={"body1"}
                          dangerouslySetInnerHTML={{__html: localizations.consumerConfirmTerms3}}/>
        </div>
      </DialogContentText>
    </Dialog>
  );
};